import { cn } from "../lib/utils";

// ---------------------------------------------------------------------------
// Skeleton — loading placeholder (pulse animation)
// ---------------------------------------------------------------------------

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-[12px] bg-muted", className)}
      {...props}
    />
  );
}

export { Skeleton };
